/**
 * PillSettingsPopover — what clicking a stage pill opens (FTP's
 * .stages-checkboxes): "move to" and "show arrow" for the selected stage on
 * the selected pipeline. It is the portaled Popover, so it floats over the
 * page under the pill and moves nothing (R14). Each tick saves at once.
 *
 *   other pill     move to + show arrow
 *   selected pill  show arrow (a plan can't move to its own stage)
 *   hidden pill    move to (hidden stages show only in the progress bar's "…")
 *
 * On a Locked page (plan 2026-10-10-001, U7) the boxes show their state and
 * take no change (AdminLockedFieldset).
 */
import type { ReactElement } from 'react';
import { AdminLockedFieldset } from '@/components/admin/AdminLockedFieldset';
import { Checkbox } from '@/components/ui/Checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/Popover';

export interface PillSettingsPopoverProps {
  stageId: number;
  stageName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The pill's label button. */
  children: ReactElement;
  offerMoveTo: boolean;
  offerShowArrow: boolean;
  moveTo: boolean;
  showArrow: boolean;
  onChange: (patch: { moveTo?: boolean; showArrow?: boolean }) => void;
}

export function PillSettingsPopover({
  stageId,
  stageName,
  open,
  onOpenChange,
  children,
  offerMoveTo,
  offerShowArrow,
  moveTo,
  showArrow,
  onChange,
}: PillSettingsPopoverProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="center"
        sideOffset={6}
        aria-label={`${stageName} settings`}
        className="w-auto min-w-[9rem] p-3"
      >
        <AdminLockedFieldset>
          <div className="flex flex-col gap-2">
            {offerMoveTo && (
              <Checkbox
                id={`stage-pill-${stageId}-move-to`}
                label="move to"
                checked={moveTo}
                onChange={(e) => onChange({ moveTo: e.target.checked })}
              />
            )}
            {offerShowArrow && (
              <Checkbox
                id={`stage-pill-${stageId}-show-arrow`}
                label="show arrow"
                checked={showArrow}
                onChange={(e) => onChange({ showArrow: e.target.checked })}
              />
            )}
          </div>
        </AdminLockedFieldset>
      </PopoverContent>
    </Popover>
  );
}
